import { render, staticRenderFns } from "./TableInspectionGroup.vue?vue&type=template&id=b616810a&scoped=true&"
import script from "./TableInspectionGroup.vue?vue&type=script&lang=js&"
export * from "./TableInspectionGroup.vue?vue&type=script&lang=js&"
import style0 from "./TableInspectionGroup.vue?vue&type=style&index=0&id=b616810a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b616810a",
  null
  
)

export default component.exports